module.exports = __webpack_public_path__ + "img/theory-and-reality--an-introduction-to-the-philosophy-of-science--second-edition-cover.c48e767c.jpg";